import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";


const getBillingInfo = async () => {
    const response = await axios.get(`taxAuthority/billing`, {headers: authHeader()});
    return response.data.result;
}

const checkPayoutEnabled = async () => {
    const response = await axios.get(`taxAuthority/billing/payoutEnabled`, {headers: authHeader()});
    return response.data.result;
}

export const taxAuthBillingApi = {
    getBillingInfo, checkPayoutEnabled,
}
